import Type from "@/model/types/Type";


const type = {
    ENDOGENOUS: 1,
    EXOGENOUS: 2,
    FUNCTIONAL_USE: 3,
    UNDETERMINED: 20,
}

const list = [
    {
        value: type.ENDOGENOUS,
        text: "Endógena",
        help: "Originada por falhas de projeto, execução, materiais ou categorias construtivos da própria edificação.",
    },
    {
        value: type.EXOGENOUS,
        text: "Exógena",
        help: "Causada por agentes externos à edificação, como ações climáticas, ambientais, do entorno ou interferências de terceiros.",
    },
    {
        value: type.FUNCTIONAL_USE,
        text: "Funcional / Uso",
        help: "Decorrente do uso inadequado, operação incorreta, sobrecarga ou falta de manutenção do sistema ou elemento inspecionado.",
    },
    {
        value: type.UNDETERMINED,
        text: "Não determinada",
        help: "Não é possível definir com segurança a origem da anomalia no momento da inspeção",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}